import { render, staticRenderFns } from "./SpclClsfListItem.vue?vue&type=template&id=530ed3d3&scoped=true"
import script from "./SpclClsfListItem.vue?vue&type=script&lang=js"
export * from "./SpclClsfListItem.vue?vue&type=script&lang=js"
import style0 from "./SpclClsfListItem.vue?vue&type=style&index=0&id=530ed3d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ed3d3",
  null
  
)

export default component.exports